import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface Workflow {
    id: string;
    name: string;
    account_id: string;
    creation_timestamp: string;
    active: boolean;
    auto_generated: boolean;
    revision: number;
    update_timestamp: string;
    type: WorkflowType;
}

export type WorkflowListResponse = PaginatedResponse<Workflow>;
export interface CreateWorkflow {
    name?: string;
    active?: boolean;
    revision?: number;
    type?: WorkflowType;
}

export interface UpdateWorkflow {
    active?: boolean;
    name?: string | null;
    revision?: number;
    type?: WorkflowType | null;
}

export interface CopyWorkflow {
    copy_account_id?: string;
}

enum QueryParams {
    TYPE = 'type',
    ACCOUNT = 'account_id'
}

export type WorkflowQueryParams = DefaultQueryParams | QueryParams;

export enum SearchWorkflowQueryParams {
    PARTIAL_TEXT = 'partial_text'
}

export enum WorkflowType {
    COLLI = 'colli',
    DECEASED = 'deceased',
    EQUIPMENT = 'equipment',
    IOT = 'iot',
    ORDER = 'order',
    PACKAGE = 'package',
    SLOT = 'slot',
    TRANSACTION = 'transaction',
    USER = 'user'
}
